import React,{useEffect,useRef,useState} from 'react'
import WebTemplate from '../Components/WebTemplate'
import { useGetAllSchoolsQuery} from '../Services/modules/school';
import { Link,useSearchParams  } from 'react-router-dom';
//import sainikshala from "../assets/img/sainikshala.jpeg";

import sainikshalaPDF from "../assets/sainikshala/Gdksst.pdf";

import tse8vi from "../assets/mahitipatrak/TSE8vi.pdf";
import TSE_mahitipatrak from "../assets/mahitipatrak/TSE_mahitipatrak.pdf";
import SSP from "../assets/mahitipatrak/SSP.pdf";



function ResultLanding() {
 
  const [filter1, setFilter1] = useState('');
  const [filter2, setFilter2] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const { 
    data: schools= [],  
    isLoading:loading=true,
    isSuccess:getSchoolSuccess=false
   } = useGetAllSchoolsQuery();
   useEffect(() => {    
     
    if (getSchoolSuccess) {
       
       
          setFilteredData(schools.data);
        
    }
   
}, [schools]);
    const ResultLandingScreen=()=>{  
    
      const handleFormSubmit = (event) => {
        event.preventDefault();
    
        const filteredItems = schools.data.filter((item) => {
          console.log("item filter", item.school_section)
          console.log("item filter", item.medium)
          console.log("filter1",filter1)
          console.log("filter1",filter2)
          return (
            item.school_section === filter1 &&
            item.medium === filter2
          );
        });
    console.log("filteredItems",filteredItems)
        setFilteredData(filteredItems);
       
      };  
      const handleLinkClick = () => {
        setSearchParams({ param1: 'value1', param2: 'value2' });
      }; 
      console.log("All Schools",schools)   
        return(
            <>
           <section class="heroschoolsResult">
  <div class="heroschoolsResult-content">
    <h2 className="text-overlay" style={{color:'#ffffff'}}>परीक्षा निकाल खालील प्रमाणे पहा</h2>
   
  </div> 
</section>


              <main id="main">
              <section id="clients" class="clients section-bg">
      <div class="container">

        <div class="row" data-aos="zoom-in">
   <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  पुढील शैक्षणिक वर्षांपासून इयत्ता ५वी व ८वी साठी गुणवत्ता शोध परीक्षा घेतली जाणार आहे.
</div>
<div className="row">
  <div className='col-md-4'>
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
   {/* <a
        href={TSE_mahitipatrak}
        target="_blank"
     //   download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
  गुणवत्ता शोध परीक्षा १ली, २री, ३री, ५वी, ६वी माहितीपत्रक बघण्यासाठी येथे क्लिक करा
  </a> */}
    <iframe
        src={TSE_mahitipatrak}
        title="Sainikshala PDF"
        width="100%"
        height="500px"
        style={{ border: "none", maxWidth: "800px" }}
      />

      <a
        href={TSE_mahitipatrak}
        download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
        Download PDF
      </a>
 
</div>
</div>
 <div className='col-md-4'>
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  {/* <a
        href={tse8vi}
        target="_blank"
     //   download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
  गुणवत्ता शोध परीक्षा ८वी माहितीपत्रक बघण्यासाठी येथे क्लिक करा
  </a> */}
   <iframe
        src={tse8vi}
        title="Sainikshala PDF"
        width="100%"
        height="500px"
        style={{ border: "none", maxWidth: "800px" }}
      />

      <a
        href={tse8vi}
        download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
        Download PDF
      </a>
 
</div>
</div>
<div className='col-md-4'>
 <div class="alert alert-danger text-center" role="alert" style={{fontWeight:'bold'}}>
  {/* <a
        href={SSP}
        target="_blank"
     //   download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
  शताब्दि शिष्यवृत्ती परीक्षा माहितीपत्रक बघण्यासाठी येथे क्लिक करा
  </a> */}
    <iframe
        src={SSP}
        title="Sainikshala PDF"
        width="100%"
        height="500px"
        style={{ border: "none", maxWidth: "800px" }}
      />

      <a
        href={SSP}
        download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
        Download PDF
      </a>
</div>
</div>
</div>
 {/* <div className="advertisement-box text-center w-100">

      <iframe
        src={sainikshalaPDF}
        title="Sainikshala PDF"
        width="100%"
        height="500px"
        style={{ border: "none", maxWidth: "800px" }}
      />

      <a
        href={sainikshalaPDF}
        download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
        Download PDF
      </a>

    </div> */}

        <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> अंतिम निकाल 2025-26</th>
         
        </tr>
      </thead>
      <tbody>
      <tr>
            <td>1</td>
            <td>           
            <Link 
            to={{ pathname: '/shatabdiResult'}}
            style={{color:'blue'}}
            >
             
            शताब्दि शिष्यवृत्ती परीक्षा 2025-26 अंतिम निकाल (४थी व ७वी)  पाहण्यासाठी क्लिक करा
              </Link>
              </td>           
          </tr>
          {/* <tr>
            <td>1</td>
            <td>           
            <Link 
            to={{ pathname: '/shatabdiResult'}}
            style={{color:'blue'}}
            >
             
            शताब्दि शिष्यवृत्ती परीक्षा 2024-25 अंतिम निकाल (४थी व ७वी)  पाहण्यासाठी क्लिक करा
              </Link>
              </td>           
          </tr> */}
      <tr>
            <td>2</td>
            <td>           
            <Link 
            to={{ pathname: '/tseresult'}}
            style={{color:'blue'}}
            >
             

गुणवत्ता शोध परीक्षा 2025-26 अंतिम निकाल  (१ली, २री, ३री, ६वी)
              </Link>
            
              </td>           
          </tr>
        
      </tbody>
    </table>
          {/* <div class="alert alert-danger" role="alert">
              अंतिम निकाल दिनांक १३ एप्रिल २०२६ रोजी जाहीर केला जाईल.
</div> */}

        </div>

      </div>
    </section>
    <section id="services" class="services">
      <div class="container" data-aos="fade-up">

       
      {/* <div class="row">
      <div className="col-12 d-flex justify-content-center" data-aos="zoom-in" data-aos-delay="100">
  <div className="advertisement-box text-center">
    <img 
      src={sainikshala} 
      alt="Sainikshala Advertisement" 
      className="img-fluid"
      style={{ maxWidth: '600px', width: '100%', height: 'auto' }}
    />
  </div>
</div>

        </div> */}

    {/* <div className="row">
  <div
    className="col-12 d-flex flex-column align-items-center"
    data-aos="zoom-in"
    data-aos-delay="100"
  >
    <div className="advertisement-box text-center w-100">

      <iframe
        src={sainikshalaPDF}
        title="Sainikshala PDF"
        width="100%"
        height="500px"
        style={{ border: "none", maxWidth: "800px" }}
      />

      <a
        href={sainikshalaPDF}
        download="Sainikshala.pdf"
        className="btn btn-success mt-3"
      >
        Download PDF
      </a>

    </div>
  </div>
</div> */}
      </div>
    </section>
{/* 
<footer id="footer">
<div class="footer-newsletter">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6" >
        <h4 style={{color:'white'}}>Find us On</h4>
        <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
        <i class="fa fa-youtube-play fa-3x "
       style={{paddingRight: "1em"}}
         aria-hidden="true"></i>
        <i class="fa fa-spotify fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
        <i class="fa fa-instagram fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
        <i class="fa fa-linkedin fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
        <i class="fa fa-facebook-square fa-3x" 
         style={{paddingRight: "1em"}}
        aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
</footer> */}


</main>
            </>
        )
    }
  return (
  <WebTemplate>
    {ResultLandingScreen()}
  </WebTemplate>
  )
}

export default ResultLanding